$R.addLang('fr', {
    'choose': 'Parcourir'
});